module.exports = __webpack_public_path__ + "img/202112-light.7616975a.png";